export default __webpack_public_path__ + "static/media/EN.e8e8a7f6.mp3";